import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import TravelPlan from "model/TravelPlan";

/**
 * @class Trip
 * @classdesc Class definition for record type from model
 * @param {OBJECT} record - The record from the model to init class
 * @extends BCMSRecord
 * @example new Trip(model.trip[0]);
 * 
 * @property {STRING} _destinationName - The name of the destination
 * @property {NUMBER} _travelPlanID - The id associated with a travel plan
 * @property {STRING} _flagIcon - The icon associated with the trip
 */
export default class Trip extends BCMSRecord {
    _destinationName;
    _travelPlanID;
    _flagIcon;

    constructor(record) {
        if(record.travelPlanID) {
            super(Object.assign(record, TravelPlan.initByID(record.travelPlanID).record));
        } else {
            super(Object.assign(record, TravelPlan.init(record).record));
        }
    }
}

Trip.define({
    "recordType" : "trip",
    "recordIDProp" : "id",
    "className": "Trip",
    "recordProperties" : [
        /**
         * @name destinationName
         * @instance
         * @property get {STRING} - gets the destination name of the trip
         * @property set {STRING} - sets the destination name of the trip
         * @memberof Trip
         */
        BCMSRecordProperty.mapToString("destinationName", "_destinationName"),

        /**
         * @name travelPlanID
         * @instance
         * @property get {STRING} - gets the id of the travel plan associated
         * @property set {STRING} - sets the id of the travel plan associated
         * @memberof Trip
         */
        BCMSRecordProperty.mapToString("travelPlanID", "_travelPlanID"),

        /**
         * @name flagIcon
         * @instance 
         * @property get {STRING} - gets the flag icon of the destination
         * @property set {STRING} - sets the flag icon of the destination
         * @memberof Trip
         */
        BCMSRecordProperty.mapToString("flagIcon", "_flagIcon")
    ].concat(TravelPlan._RecordProperties)
});